import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/GlobalStyles.css";

// Array removed, migrated to database


const PersonalProfile = ({ user, setUser, onSuccess }) => {
  console.log("PERSONAL PROFILE USER:", user);

  const [showPopup, setShowPopup] = useState(false);
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [areaSuggestions, setAreaSuggestions] = useState([]);

  const [dobError, setDobError] = useState("");
  const [dobTouched, setDobTouched] = useState(false);
  const [postalError, setPostalError] = useState("");

  const [salaryError, setSalaryError] = useState("");

  const [resumeError, setResumeError] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [profilePicFile, setProfilePicFile] = useState(null);
  const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

  /* ================= AREA SEARCH ================= */

  useEffect(() => {
    const query = user?.address?.area;
    if (!query || query.length < 2) {
      setAreaSuggestions([]);
      return;
    }

    const delay = setTimeout(async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/locations/search?query=${query}`
        );
        // Map response logic to array of objects for display
        const locs = res.data.locations || [];
        const mapped = locs.map(l => ({ name: l.area, pincode: l.pincode, obj: l }));
        setAreaSuggestions(mapped);
      } catch (err) {
        console.error(err);
      }
    }, 300);

    return () => clearTimeout(delay);
  }, [user?.address?.area]);



  /* ================= BASIC HANDLER ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;
    // FULL NAME VALIDATION
    if (name === "name") {
      const filteredValue = value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s+/g, " ")
        .trimStart();

      setUser((prev) => ({
        ...prev,
        name: filteredValue,
      }));
      return;
    }
    if (name === "email") {
      setUser((prev) => ({ ...prev, email: value.trim() }));
      return;
    }
    if (name === "phone") {
      const phone = value.replace(/\D/g, "").slice(0, 10);
      setUser((prev) => ({ ...prev, phone }));
      return;
    }
    if (name === "alternate_number") {
      const alt = value.replace(/\D/g, "").slice(0, 10);
      setUser((prev) => ({ ...prev, alternate_number: alt }));
      return;
    }


    // Handle DOB with validation
    if (name === "dob") {
      const dob = new Date(value);
      const today = new Date();

      setDobTouched(true);
      setDobError("");

      // Prevent future DOB
      if (dob > today) {
        setDobError("Date of birth cannot be a future date.");
        setUser((prev) => ({ ...prev, dob: "", age: "" }));
        return;
      }

      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      // Enforce eligibility rule
      if (age < 18) {
        setDobError("Candidate must be at least 18 years of age.");
        setUser((prev) => ({ ...prev, dob: "", age: "" }));
        return;
      }

      if (age > 60) {
        setDobError("Maximum eligible age is 60 years.");
        setUser((prev) => ({ ...prev, dob: "", age: "" }));
        return;
      }

      // Valid DOB
      setUser((prev) => ({ ...prev, dob: value, age }));
      return;
    }


    // Normal fields
    setUser((prev) => ({ ...prev, [name]: value }));
  };




  /* ================= FILE HANDLERS ================= */

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProfilePicFile(file);
    setUser((prev) => ({
      ...prev,
      profilePic: URL.createObjectURL(file),
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      setResumeError("❌ Only PDF files are allowed.");
      setResumeFile(null);
    } else {
      setResumeError("");
      setResumeFile(file);
    }
  };

  /* ================= SAVE ================= */

  const handleSave = async () => {
    if (postalError) {
      alert("Please enter a valid 6-digit postal code before saving.");
      return;
    }

    if (user.address?.postal_code && user.address.postal_code.length !== 6) {
      alert("Postal code must be exactly 6 digits.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(user.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!INDIAN_MOBILE_REGEX.test(user.phone)) {
      alert("Please enter a valid mobile number.");
      return;
    }

    if (
      user.alternate_number &&
      !INDIAN_MOBILE_REGEX.test(user.alternate_number)
    ) {
      alert("Please enter a valid alternate mobile number.");
      return;
    }




    try {
      const token = localStorage.getItem("token");
      if (!token) return alert("Please login again");

      const [first, ...rest] = user.name.trim().split(" ");
      const last = rest.join(" ");

      const formData = new FormData();

      formData.append("first", first);
      formData.append("last", last);
      formData.append("email", user.email);
      formData.append("phone", user.phone);
      formData.append("alternate_no", user.alternate_number || "");
      formData.append("dob", user.dob || "");
      formData.append("gender", user.gender || "");

      /* QUALIFICATION */
      if (user.qualification && user.qualification.length > 0) {
        // Append as comma separated string or multiple entries. 
        // Controller expects comma separated string if not array, or array.
        // FormData usually sends same-key items as list, but robust way often is comma-joined for simple text arrays if backend splits it.
        formData.append("qualification", user.qualification.join(","));
      }

      /* ADDRESS */
      formData.append("street", user.address?.street || "");
      formData.append("area", user.address?.area || "");
      formData.append("city", user.address?.city || "");
      formData.append("state", user.address?.state || "");
      formData.append("postal_code", user.address?.postal_code || "");
      formData.append("country", user.address?.country || "");
      formData.append("salary", user.salary || "");
      formData.append("experience", user.experience || "");
      formData.append("professional_Description", user.professional_Description || "");





      if (resumeFile) formData.append("resume", resumeFile);
      if (profilePicFile) formData.append("profilePic", profilePicFile);

      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/profile/update/personnel`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const c = res.data.candidate;
      console.log("Saved description from backend:", c.professional_Description);
      setUser({
        name: `${c.first_name} ${c.last_name}`.trim(),
        email: c.email,
        phone: c.phone_number,
        alternate_number: c.alternate_no || "",
        gender: c.gender || "",
        dob: c.date_of_birth || "",
        age: "",
        qualification: c.qualification || [],
        experience: c.experience || "",
        professional_Description: c.professional_Description || "",



        address: {
          street: c.address?.street || "",
          area: c.address?.area || "",
          city: c.address?.city || "",
          state: c.address?.state || "",
          postal_code: c.address?.postal_code || "",
          country: c.address?.country || "",
        },

        work_preference: {

          category: c.work_preference?.category || "",
          domain: c.work_preference?.domain || "",
        },
        salary: c.salary || "",

        profilePic: c.profilePic || "",
        resume: c.resume || "",
      });

      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2000);
      onSuccess && onSuccess();
    } catch (err) {
      console.error(err);
      alert("Failed to save profile");
    }
  };

  /* ================= UI ================= */

  return (
    <div className="page-container">
      <div className="profile-card" style={{ maxWidth: "720px", margin: "0 auto" }}>
        {/* PROFILE PIC */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={
              user?.profilePic
                ? user.profilePic.startsWith("blob")
                  ? user.profilePic
                  : `${process.env.REACT_APP_API_URL}/${user.profilePic}`
                : "https://via.placeholder.com/120"
            }
            alt="Profile"
            className="profile-avatar"
            style={{ width: 120, height: 120 }}
          />
          <label className="file-upload-label">
            Change Profile Picture
            <input type="file" hidden accept="image/*" onChange={handleProfilePicChange} />
          </label>
        </div>

        <h2 className="page-title">Personal Information</h2>

        <form>
          <label className="profile-label">Full Name</label>
          <input className="profile-input" name="name" value={user?.name || ""} onChange={handleChange} />

          <label className="profile-label">Gender</label>
          <select className="profile-input" name="gender" value={user?.gender || ""} onChange={handleChange}>
            <option value="">Select Gender</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>

          <label className="profile-label">Email</label>
          <input className="profile-input" name="email" value={user?.email || ""} onChange={handleChange} />

          <label className="profile-label">Phone</label>
          <input className="profile-input" name="phone" value={user?.phone || ""} onChange={handleChange} />

          <label className="profile-label">Alternate Phone</label>
          <input className="profile-input" name="alternate_number" value={user?.alternate_number || ""} onChange={handleChange} />

          <label className="profile-label">
            Date of Birth <span style={{ color: "#dc2626" }}>*</span>
          </label>

          <input
            type="date"
            name="dob"
            value={user?.dob ? user.dob.split("T")[0] : ""}
            onChange={handleChange}
            onBlur={() => setDobTouched(true)}
            className="profile-input"
            min={new Date(new Date().setFullYear(new Date().getFullYear() - 60))
              .toISOString()
              .split("T")[0]}
            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18))
              .toISOString()
              .split("T")[0]}
            style={{
              borderColor: dobError ? "#dc2626" : "#d1d5db",
              backgroundColor: dobError ? "#fef2f2" : "white",
            }}
          />


          {dobTouched && !dobError && (
            <div style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: "4px" }}>
              Eligible age range: 18 to 60 years
            </div>
          )}

          {dobTouched && dobError && (
            <div style={{ fontSize: "0.85rem", color: "#dc2626", marginTop: "4px" }}>
              {dobError}
            </div>
          )}


          <label className="profile-label">Age</label>
          <input className="profile-input" readOnly value={user?.age || ""} />
          <label className="profile-label">City</label>
          <select
            className="profile-input"
            value={user?.address?.city || ""}
            onChange={(e) => {
              const newCity = e.target.value;
              let normalizedCity = newCity;
              if (newCity.includes('Bengaluru')) {
                normalizedCity = 'Bengaluru';
              }

              setUser((p) => ({
                ...p,
                address: {
                  ...p.address,
                  city: normalizedCity,
                  area: normalizedCity === 'Bengaluru' ? p.address.area : ''
                },
              }))
            }}
          >
            <option value="">Select City</option>
            <option value="Bengaluru">Bengaluru</option>
            {[
              'Ballari (Bellary)', 'Belagavi (Belgaum)', 'Bengaluru',
              'Bidar', 'Chamarajanagar', 'Chikballapur', 'Chikkamagaluru (Chikmagalur)', 'Chitradurga', 'Dakshina Kannada',
              'Davangere', 'Dharwad', 'Gadag', 'Hassan', 'Haveri', 'Kalaburagi (Gulbarga)', 'Kodagu (Coorg)', 'Kolar', 'Koppal',
              'Mandya', 'Mysuru (Mysore)', 'Raichur', 'Ramanagara', 'Shivamogga (Shimoga)', 'Tumakuru (Tumkur)', 'Udupi',
              'Uttara Kannada (Karwar)', 'Vijayapura (Bijapur)', 'Yadgir', 'Vijayanagara'
            ].map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>


          {/* STREET */}
          <label className="profile-label">Street</label>
          <input
            className="profile-input"
            value={user?.address?.street || ""}
            onChange={(e) =>
              setUser((p) => ({
                ...p,
                address: { ...p.address, street: e.target.value },
              }))
            }
          />

          {/* AREA */}
          <div style={{ position: "relative" }}>
            <label className="profile-label">
              Area {(user?.address?.city !== 'Bengaluru' && user?.address?.city) && <span style={{ fontSize: '0.8rem', color: '#9ca3af', fontWeight: 'normal' }}> (Not required)</span>}
            </label>
            <input
              className="profile-input"
              value={user?.address?.area || ""}
              disabled={user?.address?.city !== 'Bengaluru'}
              style={{ backgroundColor: user?.address?.city !== 'Bengaluru' ? '#f3f4f6' : 'white' }}
              onChange={(e) =>
                setUser((p) => ({
                  ...p,
                  address: { ...p.address, area: e.target.value },
                }))
              }
              onFocus={() => {
                setShowAreaDropdown(true);
                // Refresh suggestions if Pincode exists
                if (user?.address?.postal_code && user.address.postal_code.length === 6) {
                  // Manually trigger a search with the pincode
                  axios.get(`${process.env.REACT_APP_API_URL}/api/locations/search?query=${user.address.postal_code}`)
                    .then(res => {
                      let locs = res.data.locations || [];
                      // Map objects to string representation
                      const mapped = locs.map(l => ({
                        name: l.area,
                        pincode: l.pincode,
                        obj: l
                      }));
                      setAreaSuggestions(mapped);
                    })
                    .catch(console.error);
                }
              }}
              onBlur={() => setTimeout(() => setShowAreaDropdown(false), 200)}
            />
            {showAreaDropdown && areaSuggestions.length > 0 && (
              <ul className="dropdown">
                {areaSuggestions.map((a, idx) => (
                  <li
                    key={idx}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      setUser((p) => ({
                        ...p,
                        address: {
                          ...p.address,
                          area: a.name,
                          // postal_code: a.pincode || p.address.postal_code // Removed autofill
                        },
                      }));
                      setShowAreaDropdown(false);
                    }}
                  >
                    {a.name}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* CITY */}

          <label className="profile-label">State</label>
          <select
            className="profile-input"
            value={user?.address?.state || ""}
            onChange={(e) =>
              setUser((p) => ({
                ...p,
                address: { ...p.address, state: e.target.value },
              }))
            }
          >
            <option value="">Select State</option>
            <option value="Karnataka">Karnataka</option>
            <option value="Maharashtra">Maharashtra</option>
            <option value="Telangana">Telangana</option>
          </select>


          <label className="profile-label">Postal Code</label>
          <input
            className="profile-input"
            type="text"
            placeholder="Enter 6-digit PIN code"
            value={user?.address?.postal_code || ""}
            onChange={(e) => {
              let value = e.target.value;

              setPostalError("");

              // Allow only digits
              value = value.replace(/\D/g, "");

              // Limit to 6 digits
              if (value.length > 6) return;

              const newPincode = value;

              // Validate length when fully entered
              if (value.length === 6) {
                setPostalError("");
              } else if (value.length > 0) {
                setPostalError("PIN code must be exactly 6 digits.");
              }

              setUser((p) => ({
                ...p,
                address: { ...p.address, postal_code: newPincode },
              }));

              // Direct Autofill removed as per request
              // if (newPincode.length === 6) { ... }
            }}
            style={{
              borderColor: postalError ? "#dc2626" : "#d1d5db",
              backgroundColor: postalError ? "#fef2f2" : "white",
            }}
          />

          {postalError && (
            <div style={{ color: "#dc2626", fontSize: "0.85rem", marginTop: "4px" }}>
              {postalError}
            </div>
          )}


          <label className="profile-label">Country</label>
          <select
            className="profile-input"
            value={user?.address?.country || "India"}
            disabled
          >
            <option value="India">India</option>
          </select>


          <label className="profile-label">Total Experience (Years)</label>
          <input
            className="profile-input"
            type="number"
            placeholder="e.g. 2.5"
            name="experience"
            value={user?.experience || ""}
            onChange={handleChange}
            step="0.1"
            min="0"
          />




          <label className="profile-label">Current Salary (₹)</label>
          <input
            className="profile-input"
            type="text"
            placeholder="Enter current salary"
            value={user?.salary || ""}
            onChange={(e) => {
              let value = e.target.value;

              setSalaryError("");

              // Allow only digits
              value = value.replace(/\D/g, "");

              // Limit to max 7 digits (₹99,99,999)
              if (value.length > 7) {
                setSalaryError("Salary amount is too large.");
                return;
              }

              setUser((p) => ({
                ...p,
                salary: value,
              }));
            }}
          />

          {salaryError && (
            <div style={{ color: "#dc2626", fontSize: "0.85rem", marginTop: "4px" }}>
              {salaryError}
            </div>
          )}


          <label className="profile-label">Personal Description</label>
          <textarea
            className="profile-input"
            rows={4}
            placeholder="Write a short professional summary about yourself..."
            value={user?.professional_Description || ""}
            onChange={(e) => {
              if (e.target.value.length <= 500) {
                setUser((p) => ({
                  ...p,
                  professional_Description: e.target.value,
                }));
              }
            }}

          />


          <label className="profile-label">Resume (PDF)</label>
          {user?.resume ? (
            <div style={{ marginBottom: "20px", display: "flex", alignItems: "center", gap: "15px" }}>
              <a
                href={`${process.env.REACT_APP_API_URL}/${user.resume}`}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "12px 16px",
                  backgroundColor: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  borderRadius: "8px",
                  color: "#1d4ed8",
                  textDecoration: "none",
                  fontWeight: "600",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#dbeafe"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#eff6ff"}
              >
                View Uploaded Resume
              </a>

              <button
                type="button"
                onClick={() => {
                  if (window.confirm("Are you sure you want to delete this resume?")) {
                    setUser((prev) => ({ ...prev, resume: "" }));
                  }
                }}
                className="danger-btn"
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 16px",
                  height: "100%"
                }}
                title="Remove resume"
              >
                Delete
              </button>
            </div>
          ) : (
            <input type="file" accept=".pdf" onChange={handleFileChange} />
          )}
          {resumeError && <div style={{ color: "red" }}>{resumeError}</div>}

          <button type="button" className="save-button" onClick={handleSave}>
            Save Personal Information
          </button>
        </form>

        {showPopup && <div className="profile-popup">✅ Profile updated successfully!</div>}
      </div>
    </div>
  );
};

export default PersonalProfile;
